import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { initSentry } from './lib/sentry'
import { initPerformanceMonitoring } from './lib/performance'
import { initAnalyticsScripts } from './lib/analytics-init'

// Initialize error tracking and performance monitoring
initSentry()
initPerformanceMonitoring()
initAnalyticsScripts()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
